/**
 * Thank-you / person-details booking strings — merged when missing from locale files.
 * Keeps the person step fluent in all UI languages (see LOCALIZED_FALLBACK_ORDER).
 */
const shared = {
  en: {
    personLabel: 'Devotee',
    personFieldLabel: 'Person {n} {attr}',
    backToPooja: 'Back to pooja',
    poojaInfo: 'Pooja Info',
    secureCheckout: 'Secure Checkout',
    securePayment: 'Secure Payment',
    personNameRequired: 'Please add at least one person with name.',
    needPrasadamNo: 'NO',
    needPrasadamYes: 'YES',
    preparingAutopay: 'Preparing your booking… Please wait.',
  },
  hi: {
    personLabel: 'भक्त',
    personFieldLabel: 'व्यक्ति {n} {attr}',
    backToPooja: 'पूजा पर वापस',
    secureCheckout: 'सुरक्षित चेकआउट',
    personNameRequired: 'कृपया नाम के साथ कम से कम एक व्यक्ति जोड़ें।',
    needPrasadamNo: 'नहीं',
    needPrasadamYes: 'हाँ',
    preparingAutopay: 'आपकी बुकिंग तैयार हो रही है… कृपया प्रतीक्षा करें।',
  },
  te: {
    personLabel: 'భక్తుడు',
    personFieldLabel: 'వ్యక్తి {n} {attr}',
    backToPooja: 'పూజాకు తిరిగి',
    secureCheckout: 'సురక్షిత చెక్అవుట్',
    personNameRequired: 'దయచేసి పేరుతో కనీసం ఒక వ్యక్తిని జోడించండి.',
    needPrasadamNo: 'కాదు',
    needPrasadamYes: 'అవును',
    preparingAutopay: 'మీ బుకింగ్ సిద్ధమవుతోంది… దయచేసి వేచి ఉండండి.',
  },
  kn: {
    personLabel: 'ಭಕ್ತ',
    personFieldLabel: 'ವ್ಯಕ್ತಿ {n} {attr}',
    backToPooja: 'ಪೂಜೆಗೆ ಹಿಂದೆ',
    secureCheckout: 'ಸುರಕ್ಷಿತ ಚೆಕ್‌ಔಟ್',
    personNameRequired: 'ದಯವಿಟ್ಟು ಹೆಸರಿನೊಂದಿಗೆ ಕನೀಸ್ ಒಬ್ಬ ವ್ಯಕ್ತಿಯನ್ನು ಸೇರಿಸಿ.',
    needPrasadamNo: 'ಇಲ್ಲ',
    needPrasadamYes: 'ಹೌದು',
    preparingAutopay: 'ನಿಮ್ಮ ಬುಕಿಂಗ್ ಸಿದ್ಧವಾಗುತ್ತಿದೆ… ದಯವಿಟ್ಟು ಕಾಯಿರಿ.',
  },
  ta: {
    personLabel: 'பக்தர்',
    personFieldLabel: 'நபர் {n} {attr}',
    backToPooja: 'பூஜைக்குத் திரும்ப',
    secureCheckout: 'பாதுகாப்பான செக்அவுட்',
    personNameRequired: 'பெயருடன் குறைந்தது ஒரு நபரைச் சேர்க்கவும்.',
    needPrasadamNo: 'இல்லை',
    needPrasadamYes: 'ஆம்',
    preparingAutopay: 'உங்கள் பதிவு தயாராகிறது… தயவுசெய்து காத்திருக்கவும்.',
    prasadamSkipBlockedHint: 'தவிர்க்கும் முன் பிரசாதம் விநியோக முகவரியைச் சேர்க்கவும்.',
    prasadamAddressRequired: 'பிரசாதம் விநியோகத்திற்கு {label} அவசியம்',
    prasadamPincodeInvalid: 'சரியான 6-இலக்க PIN குறியீட்டை உள்ளிடவும்',
    prasadamSubmitRequiredHint: 'சமர்ப்பிக்க முகவரி மற்றும் 6-இலக்க PIN நிரப்பவும்',
    maxPersonsReached: 'அதிகபட்ச நபர் வரம்பு நிரைந்தது',
    minMembers: 'குறைந்தபட்சம்',
    removePerson: 'நீக்கு',
    removePersonConfirmTitle: 'இந்த நபரை நீக்கவா?',
    removePersonConfirmBody: 'நபர் {n} விவரங்களை நீக்க விரும்புகிறீர்களா?',
    removePersonConfirmNo: 'இல்லை',
    removePersonConfirmYes: 'ஆம், நீக்கு',
    personDetailsSuccess: 'நபர் விவரங்கள் வெற்றிகரமாக சேமிக்கப்பட்டன!',
    editPersonDetails: 'நபர் விவரங்களைத் திருத்து',
  },
  ml: {
    personLabel: 'ഭക്തൻ',
    personFieldLabel: 'വ്യക്തി {n} {attr}',
    backToPooja: 'പൂജയിലേക്ക് തിരികെ',
    secureCheckout: 'സുരക്ഷിത ചെക്കൗട്ട്',
    personNameRequired: 'ദയവായി പേരുള്ള കുറഞ്ഞത് ഒരു വ്യക്തിയെ ചേർക്കുക.',
    needPrasadamNo: 'ഇല്ല',
    needPrasadamYes: 'അതെ',
    preparingAutopay: 'നിങ്ങളുടെ ബുക്കിംഗ് തയ്യാറാക്കുന്നു… ദയവായി കാത്തിരിക്കുക.',
    prasadamSkipBlockedHint: 'ഒഴിവാക്കുന്നതിന് മുമ്പ് പ്രസാദം വിതരണ വിലാസം ചേർക്കുക.',
    prasadamAddressRequired: 'പ്രസാദം വിതരണത്തിന് {label} ആവശ്യമാണ്',
    prasadamPincodeInvalid: 'സാധുവായ 6-അക്ക PIN കോഡ് നൽകുക',
    prasadamSubmitRequiredHint: 'സമർപ്പിക്കാൻ വിലാസവും 6-അക്ക PIN-ഉം നൽകുക',
    maxPersonsReached: 'പരമാവധി വ്യക്തികളുടെ എണ്ണം എത്തി',
    minMembers: 'കുറഞ്ഞത്',
    removePerson: 'നീക്കം ചെയ്യുക',
    removePersonConfirmTitle: 'ഈ വ്യക്തിയെ നീക്കം ചെയ്യണോ?',
    removePersonConfirmBody: 'വ്യക്തി {n} വിവരങ്ങൾ നീക്കം ചെയ്യണമോ?',
    removePersonConfirmNo: 'ഇല്ല',
    removePersonConfirmYes: 'അതെ, നീക്കം ചെയ്യുക',
    personDetailsSuccess: 'വ്യക്തി വിവരങ്ങൾ വിജയകരമായി സേവ് ചെയ്തു!',
    editPersonDetails: 'വ്യക്തി വിവരങ്ങൾ എഡിറ്റ് ചെയ്യുക',
  },
  mr: {
    personLabel: 'भक्त',
    personFieldLabel: 'व्यक्ती {n} {attr}',
    backToPooja: 'पूजेकडे परत',
    secureCheckout: 'सुरक्षित चेकआउट',
    personNameRequired: 'कृपया नावासह किमान एक व्यक्ती जोडा.',
    needPrasadamNo: 'नाही',
    needPrasadamYes: 'होय',
    preparingAutopay: 'तुमची बुकिंग तयार होत आहे… कृपया प्रतीक्षा करा.',
    prasadamSkipBlockedHint: 'वगळण्यापूर्वी प्रसाद वितरण पत्ता जोडा.',
    prasadamAddressRequired: 'प्रसाद वितरणासाठी {label} आवश्यक आहे',
    prasadamPincodeInvalid: 'वैध 6-अंकी पिनकोड प्रविष्ट करा',
    prasadamSubmitRequiredHint: 'सबमिट करण्यासाठी पत्ता आणि 6-अंकी पिनकोड भरा',
    maxPersonsReached: 'कमाल व्यक्ती मर्यादा पूर्ण',
    minMembers: 'किमान',
    removePerson: 'काढा',
    removePersonConfirmTitle: 'ही व्यक्ती काढायची?',
    removePersonConfirmBody: 'तुम्हाला व्यक्ती {n} तपशील काढायचे आहेत का?',
    removePersonConfirmNo: 'नाही',
    removePersonConfirmYes: 'होय, काढा',
    personDetailsSuccess: 'व्यक्ती तपशील यशस्वीरित्या जतन केले!',
    editPersonDetails: 'व्यक्ती तपशील संपादित करा',
  },
  gu: {
    personLabel: 'ભક્ત',
    personFieldLabel: 'વ્યક્તિ {n} {attr}',
    backToPooja: 'પૂજા પર પાછા',
    secureCheckout: 'સુરક્ષિત ચેકઆઉટ',
    personNameRequired: 'કૃપા કરીને નામ સાથે ઓછામાં ઓછી એક વ્યક્તિ ઉમેરો.',
    needPrasadamNo: 'ના',
    needPrasadamYes: 'હા',
    preparingAutopay: 'તમારી બુકિંગ તૈયાર થઈ રહી છે… કૃપા કરીને રાહ જુઓ.',
    prasadamSkipBlockedHint: 'છોડતા પહેલાં પ્રસાદ વિતરણ સરનામું ઉમેરો.',
    prasadamAddressRequired: 'પ્રસાદ વિતરણ માટે {label} જરૂરી છે',
    prasadamPincodeInvalid: 'માન્ય 6-અંકનો પિનકોડ દાખલ કરો',
    prasadamSubmitRequiredHint: 'સબમિટ કરવા માટે સરનામું અને 6-અંકનો પિનકોડ ભરો',
    maxPersonsReached: 'મહત્તમ વ્યક્તિ મર્યાદા પૂર્ણ',
    minMembers: 'ન્યૂનતમ',
    removePerson: 'દૂર કરો',
    removePersonConfirmTitle: 'આ વ્યક્તિ દૂર કરવી?',
    removePersonConfirmBody: 'શું તમે વ્યક્તિ {n} વિગતો દૂર કરવા માંગો છો?',
    removePersonConfirmNo: 'ના',
    removePersonConfirmYes: 'હા, દૂર કરો',
    personDetailsSuccess: 'વ્યક્તિ વિગતો સફળતાપૂર્વક સાચવી!',
    editPersonDetails: 'વ્યક્તિ વિગતો સંપાદિત કરો',
  },
};

/** Full thank-you person step for locales without a booking section. */
const fullThankYou = (langPack) => ({
  step1Title: langPack.step1Title,
  step2Title: langPack.step2Title,
  step3Title: langPack.step3Title,
  step3Desc: langPack.step3Desc,
  personName: langPack.personName,
  personGothra: langPack.personGothra,
  personNakshatra: langPack.personNakshatra,
  personRashi: langPack.personRashi,
  addPerson: langPack.addPerson,
  submitPersonDetails: langPack.submitPersonDetails,
  skipForNow: langPack.skipForNow,
  addPersonDetails: langPack.addPersonDetails,
  orderConfirmedTitle: langPack.orderConfirmedTitle,
  orderConfirmedDesc: langPack.orderConfirmedDesc,
  needPrasadamLabel: langPack.needPrasadamLabel,
  needPrasadamDesc: langPack.needPrasadamDesc,
  redirecting: langPack.redirecting,
  ...langPack,
});

const bnPack = fullThankYou({
  step1Title: 'ভক্তের বিবরণ যোগ করুন',
  step2Title: 'পেমেন্ট',
  step3Title: 'পরিবার ও সংকল্প বিবরণ পূরণ করুন',
  step3Desc: 'অনুষ্ঠানের জন্য সংকল্প বিবরণ যোগ করুন। পুরোহিত পূজার সময় আপনার ইচ্ছা ঘোষণা করবেন।',
  personName: 'নাম',
  personGothra: 'গোত্র',
  personNakshatra: 'নক্ষত্র',
  personRashi: 'রাশি',
  addPerson: 'আরও একজন যোগ করুন',
  submitPersonDetails: 'বিবরণ জমা দিন',
  skipForNow: 'এখন এড়িয়ে যান',
  addPersonDetails: 'সংকল্পের জন্য ব্যক্তির বিবরণ যোগ করুন',
  orderConfirmedTitle: 'ধন্যবাদ – অর্ডার নিশ্চিত',
  orderConfirmedDesc: 'আপনার পূজা বুকিং নিশ্চিত হয়েছে। সম্পূর্ণ করতে বিবরণ যোগ করুন।',
  needPrasadamLabel: 'আপনি কি প্রসাদ চান?',
  needPrasadamDesc: 'এই প্রসাদ আপনার দোরগোড়ায় পৌঁছে দেওয়া হবে।',
  redirecting: 'পেমেন্টে পুনঃনির্দেশিত হচ্ছে…',
  personLabel: 'ভক্ত',
  personFieldLabel: 'ব্যক্তি {n} {attr}',
  backToPooja: 'পূজায় ফিরে যান',
  secureCheckout: 'নিরাপদ চেকআউট',
  personNameRequired: 'অনুগ্রহ করে নামসহ কমপক্ষে একজন ব্যক্তি যোগ করুন।',
  needPrasadamNo: 'না',
  needPrasadamYes: 'হ্যাঁ',
  preparingAutopay: 'আপনার বুকিং প্রস্তুত হচ্ছে… অনুগ্রহ করে অপেক্ষা করুন।',
  prasadamSkipBlockedHint: 'এড়িয়ে যাওয়ার আগে প্রসাদ ডেলিভারি ঠিকানা যোগ করুন।',
  prasadamAddressRequired: 'প্রসাদ ডেলিভারির জন্য {label} প্রয়োজন',
  prasadamPincodeInvalid: 'সঠিক ৬-অঙ্কের পিনকোড লিখুন',
  prasadamSubmitRequiredHint: 'জমা দিতে ঠিকানা ও ৬-অঙ্কের পিনকোড পূরণ করুন',
  maxPersonsReached: 'সর্বোচ্চ ব্যক্তির সীমা পূর্ণ',
  minMembers: 'সর্বনিম্ন',
  removePerson: 'সরান',
  removePersonConfirmTitle: 'এই ব্যক্তি সরাবেন?',
  removePersonConfirmBody: 'আপনি কি ব্যক্তি {n} এর বিবরণ সরাতে চান?',
  removePersonConfirmNo: 'না',
  removePersonConfirmYes: 'হ্যাঁ, সরান',
  personDetailsSuccess: 'ব্যক্তির বিবরণ সফলভাবে সংরক্ষিত!',
  editPersonDetails: 'ব্যক্তির বিবরণ সম্পাদনা',
});

const paPack = fullThankYou({
  step1Title: 'ਭਗਤ ਵੇਰਵੇ ਜੋੜੋ',
  step2Title: 'ਭੁਗਤਾਨ',
  step3Title: 'ਪਰਿਵਾਰ ਅਤੇ ਸੰਕਲਪ ਵੇਰਵੇ ਭਰੋ',
  step3Desc: 'ਰਸਮ ਲਈ ਸੰਕਲਪ ਵੇਰਵੇ ਜੋੜੋ। ਪੁਜਾਰੀ ਪੂਜਾ ਦੌਰਾਨ ਤੁਹਾਡੀ ਮੰਗ ਘੋਸ਼ਿਤ ਕਰੇਗਾ।',
  personName: 'ਨਾਮ',
  personGothra: 'ਗੋਤਰ',
  personNakshatra: 'ਨਕਸ਼ਤਰ',
  personRashi: 'ਰਾਸ਼ੀ',
  addPerson: 'ਹੋਰ ਇੱਕ ਵਿਅਕਤੀ ਜੋੜੋ',
  submitPersonDetails: 'ਵੇਰਵੇ ਜਮ੍ਹਾਂ ਕਰੋ',
  skipForNow: 'ਹੁਣ ਛੱਡੋ',
  addPersonDetails: 'ਸੰਕਲਪ ਲਈ ਵਿਅਕਤੀ ਵੇਰਵੇ ਜੋੜੋ',
  orderConfirmedTitle: 'ਧੰਨਵਾਦ – ਆਰਡਰ ਪੁਸ਼ਟ',
  orderConfirmedDesc: 'ਤੁਹਾਡੀ ਪੂਜਾ ਬੁਕਿੰਗ ਪੁਸ਼ਟ ਹੈ। ਪੂਰਾ ਕਰਨ ਲਈ ਵੇਰਵੇ ਜੋੜੋ।',
  needPrasadamLabel: 'ਕੀ ਤੁਸੀਂ ਪ੍ਰਸਾਦ ਚਾਹੁੰਦੇ ਹੋ?',
  needPrasadamDesc: 'ਇਹ ਪ੍ਰਸਾਦ ਤੁਹਾਡੇ ਘਰ ਪਹੁੰਚਾਇਆ ਜਾਵੇਗਾ।',
  redirecting: 'ਭੁਗਤਾਨ ਵੱਲ ਰੀਡਾਇਰੈਕਟ…',
  personLabel: 'ਭਕਤ',
  personFieldLabel: 'ਵਿਅਕਤੀ {n} {attr}',
  backToPooja: 'ਪੂਜਾ ਵੱਲ ਵਾਪਸ',
  secureCheckout: 'ਸੁਰੱਖਿਅਤ ਚੈਕਆਉਟ',
  personNameRequired: 'ਕਿਰਪਾ ਕਰਕੇ ਨਾਮ ਨਾਲ ਘੱਟੋ-ਘੱਟ ਇੱਕ ਵਿਅਕਤੀ ਜੋੜੋ।',
  needPrasadamNo: 'ਨਹੀਂ',
  needPrasadamYes: 'ਹਾਂ',
  preparingAutopay: 'ਤੁਹਾਡੀ ਬੁਕਿੰਗ ਤਿਆਰ ਹੋ ਰਹੀ ਹੈ… ਕਿਰਪਾ ਕਰਕੇ ਉਡੀਕ ਕਰੋ।',
  prasadamSkipBlockedHint: 'ਛੱਡਣ ਤੋਂ ਪਹਿਲਾਂ ਪ੍ਰਸਾਦ ਡਿਲਿਵਰੀ ਪਤਾ ਜੋੜੋ।',
  prasadamAddressRequired: 'ਪ੍ਰਸਾਦ ਡਿਲਿਵਰੀ ਲਈ {label} ਲੋੜੀਂਦਾ ਹੈ',
  prasadamPincodeInvalid: 'ਸਹੀ 6-ਅੰਕ ਦਾ ਪਿਨਕੋਡ ਦਾਖਲ ਕਰੋ',
  prasadamSubmitRequiredHint: 'ਜਮ੍ਹਾਂ ਕਰਨ ਲਈ ਪਤਾ ਅਤੇ 6-ਅੰਕ ਪਿਨਕੋਡ ਭਰੋ',
  maxPersonsReached: 'ਵੱਧ ਤੋਂ ਵੱਧ ਵਿਅਕਤੀ ਸੀਮਾ ਪੂਰੀ',
  minMembers: 'ਘੱਟੋ-ਘੱਟ',
  removePerson: 'ਹਟਾਓ',
  removePersonConfirmTitle: 'ਇਸ ਵਿਅਕਤੀ ਨੂੰ ਹਟਾਉਣਾ ਹੈ?',
  removePersonConfirmBody: 'ਕੀ ਤੁਸੀਂ ਵਿਅਕਤੀ {n} ਵੇਰਵੇ ਹਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?',
  removePersonConfirmNo: 'ਨਹੀਂ',
  removePersonConfirmYes: 'ਹਾਂ, ਹਟਾਓ',
  personDetailsSuccess: 'ਵਿਅਕਤੀ ਵੇਰਵੇ ਸਫਲਤਾਪੂਰਵਕ ਸੁਰੱਖਿਅਤ!',
  editPersonDetails: 'ਵਿਅਕਤੀ ਵੇਰਵੇ ਸੰਪਾਦਿਤ ਕਰੋ',
});

const orPack = fullThankYou({
  step1Title: 'ଭକ୍ତ ବିବରଣୀ ଯୋଡ଼ନ୍ତୁ',
  step2Title: 'ପେମେଣ୍ଟ',
  step3Title: 'ପରିବାର ଓ ସଙ୍କଳ୍ପ ବିବରଣୀ ପୂରଣ କରନ୍ତୁ',
  step3Desc: 'ଅନୁଷ୍ଠାନ ପାଇଁ ସଙ୍କଳ୍ପ ବିବରଣୀ ଯୋଡ଼ନ୍ତୁ। ପୁଜାରୀ ପୂଜା ସମୟରେ ଆପଣଙ୍କ ଇଚ୍ଛା ଘୋଷଣା କରିବେ।',
  personName: 'ନାମ',
  personGothra: 'ଗୋତ୍ର',
  personNakshatra: 'ନକ୍ଷତ୍ର',
  personRashi: 'ରାଶି',
  addPerson: 'ଆଉ ଜଣେ ଯୋଡ଼ନ୍ତୁ',
  submitPersonDetails: 'ବିବରଣୀ ଦାଖଲ କରନ୍ତୁ',
  skipForNow: 'ଏବେ ଛାଡ଼ି ଦିଅନ୍ତୁ',
  addPersonDetails: 'ସଙ୍କଳ୍ପ ପାଇଁ ବ୍ୟକ୍ତି ବିବରଣୀ ଯୋଡ଼ନ୍ତୁ',
  orderConfirmedTitle: 'ଧନ୍ୟବାଦ – ଅର୍ଡର ନିଶ୍ଚିତ',
  orderConfirmedDesc: 'ଆପଣଙ୍କ ପୂଜା ବୁକିଂ ନିଶ୍ଚିତ। ସମ୍ପୂର୍ଣ୍ଣ କରିବା ପାଇଁ ବିବରଣୀ ଯୋଡ଼ନ୍ତୁ।',
  needPrasadamLabel: 'ଆପଣ ପ୍ରସାଦ ଚାହୁଁଛନ୍ତି କି?',
  needPrasadamDesc: 'ଏହି ପ୍ରସାଦ ଆପଣଙ୍କ ଘରକୁ ପହଞ୍ଚାଯିବ।',
  redirecting: 'ପେମେଣ୍ଟକୁ ପଠାଯାଉଛି…',
  personLabel: 'ଭକ୍ତ',
  personFieldLabel: 'ବ୍ୟକ୍ତି {n} {attr}',
  backToPooja: 'ପୂଜାକୁ ଫେରନ୍ତୁ',
  secureCheckout: 'ସୁରକ୍ଷିତ ଚେକଆଉଟ',
  personNameRequired: 'ଦୟାକରି ନାମ ସହିତ ଅତିକମରେ ଜଣେ ବ୍ୟକ୍ତି ଯୋଡ଼ନ୍ତୁ।',
  needPrasadamNo: 'ନା',
  needPrasadamYes: 'ହଁ',
  preparingAutopay: 'ଆପଣଙ୍କ ବୁକିଂ ପ୍ରସ୍ତୁତ ହେଉଛି… ଦୟାକରି ଅପେକ୍ଷା କରନ୍ତୁ।',
  prasadamSkipBlockedHint: 'ଛାଡିବା ପୂର୍ବରୁ ପ୍ରସାଦ ଡେଲିଭାରି ଠିକଣା ଯୋଡ଼ନ୍ତୁ।',
  prasadamAddressRequired: 'ପ୍ରସାଦ ଡେଲିଭାରି ପାଇଁ {label} ଆବଶ୍ୟକ',
  prasadamPincodeInvalid: 'ସଠିକ 6-ଅଙ୍କର ପିନକୋଡ ଲେଖନ୍ତୁ',
  prasadamSubmitRequiredHint: 'ଦାଖଲ ପାଇଁ ଠିକଣା ଏବଂ 6-ଅଙ୍କ ପିନକୋଡ ପୂରଣ କରନ୍ତୁ',
  maxPersonsReached: 'ସର୍ବୋଚ୍ଚ ବ୍ୟକ୍ତି ସୀମା ପୂର୍ଣ୍ଣ',
  minMembers: 'ସର୍ବନିମ୍ନ',
  removePerson: 'ହଟାନ୍ତୁ',
  removePersonConfirmTitle: 'ଏହି ବ୍ୟକ୍ତି ହଟାଇବେ?',
  removePersonConfirmBody: 'ଆପଣ ବ୍ୟକ୍ତି {n} ବିବରଣୀ ହଟାଇବାକୁ ଚାହୁଁଛନ୍ତି କି?',
  removePersonConfirmNo: 'ନା',
  removePersonConfirmYes: 'ହଁ, ହଟାନ୍ତୁ',
  personDetailsSuccess: 'ବ୍ୟକ୍ତି ବିବରଣୀ ସଫଳତାର ସହିତ ସଞ୍ଚିତ!',
  editPersonDetails: 'ବ୍ୟକ୍ତି ବିବରଣୀ ସମ୍ପାଦନା',
});

const asPack = fullThankYou({
  step1Title: 'ভক্তৰ বিৱৰণ যোগ কৰক',
  step2Title: 'পৰিশোধ',
  step3Title: 'পৰিয়াল আৰু সঙ্কল্প বিৱৰণ পূৰণ কৰক',
  step3Desc: 'অনুষ্ঠানৰ বাবে সংকল্পৰ বিৱৰণ যোগ কৰক। পুজাৰীয়ে পূজাৰ সময়ত আপোনাৰ ইচ্ছা ঘোষণা কৰিব।',
  personName: 'নাম',
  personGothra: 'গোত্ৰ',
  personNakshatra: 'নক্ষত্ৰ',
  personRashi: 'ৰাশি',
  addPerson: 'আৰু এজন যোগ কৰক',
  submitPersonDetails: 'বিৱৰণ দাখিল কৰক',
  skipForNow: 'এতিয়া এৰি দিয়ক',
  addPersonDetails: 'সংকল্পৰ বাবে ব্যক্তিৰ বিৱৰণ যোগ কৰক',
  orderConfirmedTitle: 'ধন্যবাদ – অৰ্ডাৰ নিশ্চিত',
  orderConfirmedDesc: 'আপোনাৰ পূজা বুকিং নিশ্চিত। সম্পূৰ্ণ কৰিবলৈ বিৱৰণ যোগ কৰক।',
  needPrasadamLabel: 'আপুনি প্ৰসাদ বিচাৰেনে?',
  needPrasadamDesc: 'এই প্ৰসাদ আপোনাৰ ঘৰলৈ পৌঁচ দিয়া হ’ব।',
  redirecting: 'পৰিশোধলৈ পুনঃনিৰ্দেশিত…',
  personLabel: 'ভক্ত',
  personFieldLabel: 'ব্যক্তি {n} {attr}',
  backToPooja: 'পূজালৈ উভতি যাওক',
  secureCheckout: 'সুৰক্ষিত চেকআউট',
  personNameRequired: 'অনুগ্ৰহ কৰি নামসহ কমেও এজন ব্যক্তি যোগ কৰক।',
  needPrasadamNo: 'নহয়',
  needPrasadamYes: 'হয়',
  preparingAutopay: 'আপোনাৰ বুকিং প্রস্তুত হৈ আছে… অনুগ্ৰহ কৰি অপেক্ষা কৰক।',
  prasadamSkipBlockedHint: 'এৰি যোৱাৰ আগতে প্ৰসাদ ডেলিভাৰি ঠিকনা যোগ কৰক।',
  prasadamAddressRequired: 'প্ৰসাদ ডেলিভাৰিৰ বাবে {label} প্ৰয়োজন',
  prasadamPincodeInvalid: 'শুদ্ধ ৬-অংকীয় পিনক’ড লিখক',
  prasadamSubmitRequiredHint: 'দাখিল কৰিবলৈ ঠিকনা আৰু ৬-অংকীয় পিনক’ড পূৰণ কৰক',
  maxPersonsReached: 'সৰ্বোচ্চ ব্যক্তি সীমা পূৰণ',
  minMembers: 'সৰ্বনিম্ন',
  removePerson: 'আঁতৰাওক',
  removePersonConfirmTitle: 'এই ব্যক্তি আঁতৰাবনে?',
  removePersonConfirmBody: 'আপুনি ব্যক্তি {n} ৰ বিৱৰণ আঁতৰাব বিচাৰেনে?',
  removePersonConfirmNo: 'নহয়',
  removePersonConfirmYes: 'হয়, আঁতৰাওক',
  personDetailsSuccess: 'ব্যক্তিৰ বিৱৰণ সফলতাৰে সংৰক্ষিত!',
  editPersonDetails: 'ব্যক্তিৰ বিৱৰণ সম্পাদনা',
});

const nePack = fullThankYou({
  step1Title: 'भक्त विवरण थप्नुहोस्',
  step2Title: 'भुक्तानी',
  step3Title: 'परिवार र संकल्प विवरण भर्नुहोस्',
  step3Desc: 'अनुष्ठानका लागि संकल्प विवरण थप्नुहोस्। पुजारीले पूजा अवधिमा तपाईंको इच्छा घोषणा गर्नेछन्।',
  personName: 'नाम',
  personGothra: 'गोत्र',
  personNakshatra: 'नक्षत्र',
  personRashi: 'राशि',
  addPerson: 'अर्को व्यक्ति थप्नुहोस्',
  submitPersonDetails: 'विवरण पेश गर्नुहोस्',
  skipForNow: 'अहिले छोड्नुहोस्',
  addPersonDetails: 'संकल्पका लागि व्यक्ति विवरण थप्नुहोस्',
  orderConfirmedTitle: 'धन्यवाद – अर्डर पुष्टि',
  orderConfirmedDesc: 'तपाईंको पूजा बुकिङ पुष्टि भयो। पूरा गर्न विवरण थप्नुहोस्।',
  needPrasadamLabel: 'के तपाईं प्रसाद चाहनुहुन्छ?',
  needPrasadamDesc: 'यो प्रसाद तपाईंको घरमा पुर्याइनेछ।',
  redirecting: 'भुक्तानीतर्फ पठाइँदै…',
  personLabel: 'भक्त',
  personFieldLabel: 'व्यक्ति {n} {attr}',
  backToPooja: 'पूजामा फर्कनुहोस्',
  secureCheckout: 'सुरक्षित चेकआउट',
  personNameRequired: 'कृपया नामसहित कम्तीमा एक व्यक्ति थप्नुहोस्।',
  needPrasadamNo: 'होइन',
  needPrasadamYes: 'हो',
  preparingAutopay: 'तपाईंको बुकिङ तयार हुँदैछ… कृपया पर्खनुहोस्।',
  prasadamSkipBlockedHint: 'छोड्नुअघि प्रसाद वितरण ठेगाना थप्नुहोस्।',
  prasadamAddressRequired: 'प्रसाद वितरणका लागि {label} आवश्यक छ',
  prasadamPincodeInvalid: 'मान्य ६-अङ्कको पिनकोड प्रविष्ट गर्नुहोस्',
  prasadamSubmitRequiredHint: 'पेश गर्न ठेगाना र ६-अङ्कको पिनकोड भर्नुहोस्',
  maxPersonsReached: 'अधिकतम व्यक्ति सीमा पुग्यो',
  minMembers: 'न्यूनतम',
  removePerson: 'हटाउनुहोस्',
  removePersonConfirmTitle: 'यो व्यक्ति हटाउने?',
  removePersonConfirmBody: 'के तपाईं व्यक्ति {n} को विवरण हटाउन चाहनुहुन्छ?',
  removePersonConfirmNo: 'होइन',
  removePersonConfirmYes: 'हो, हटाउनुहोस्',
  personDetailsSuccess: 'व्यक्ति विवरण सफलतापूर्वक सुरक्षित!',
  editPersonDetails: 'व्यक्ति विवरण सम्पादन',
});

export const BOOKING_PERSON_PAGE_OVERLAY = {
  ...shared,
  bn: bnPack,
  pa: paPack,
  or: orPack,
  as: asPack,
  ne: nePack,
};
